module.exports = __webpack_public_path__ + "static/media/honeycomb-mobile.63191b9f.svg";